<template>
<div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="12">
            <left-emp-menu></left-emp-menu>
          </v-col>
          <v-col>
            <v-row>
              <v-col cols="12">
              <v-container fluid>
                <v-row dense>

                    <!-- ข้อมูลส่วนตัว -->
                    <v-col cols="12">
                        <v-expansion-panels focusable v-model="panel" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header disable-icon-rotate>
                                <template v-slot:actions>
                                    <v-icon color="#871B12"> mdi-account-circle-outline </v-icon>
                                </template>
                            ข้อมูลส่วนตัว
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                            <v-card elevation="2">
                                    <v-card >
                                      <center>
                                        <v-avatar
                                             class="profile"
                                             style="margin-top:10px"
                                              color="grey"
                                              size="164"
                                              rounded>
                                            <v-img
                                                :src="dataImg"
                                            ></v-img>
                                        </v-avatar>
                                      </center>
                                        <v-col>
                                            <v-card-text><v-icon color="#871B12">mdi-account</v-icon><strong>ชื่อ-นามสกุล (ภาษาไทย): </strong>{{ formUpdate.empFull_NameTH }} </v-card-text>
                                            <v-card-text><v-icon color="#871B12">mdi-account</v-icon><strong>ชื่อ-นามสกุล (ภาษาอังกฤษ): </strong>{{ formUpdate.empFull_NameEN }} </v-card-text>
                                            <v-card-text><v-icon color="#871B12">mdi-account</v-icon><strong>ชื่อเล่น: </strong> {{ formUpdate.empNickname }} <v-icon color="#871B12">mdi-account</v-icon><strong>เพศ : </strong> {{ formUpdate.empGender }}</v-card-text>
                                            <v-card-text :value="computedDateBB" :return-value.sync="date"><v-icon color="#871B12"> mdi-cake-variant </v-icon><strong>วัน-เดือน-ปีเกิด : </strong>{{ showDateTH }}</v-card-text>
                                        </v-col>
                                        <v-col>
                                            <v-card-text><v-icon color="#871B12">mdi-account-box</v-icon><strong>เลขบัตรประจำตัวประชาชน : </strong>{{ formUpdate.empIDCard }}</v-card-text>
                                            <v-card-text><v-icon color="#871B12"> mdi-cellphone-basic </v-icon><strong>เบอร์โทรศัพท์ : </strong>{{ formUpdate.empTel }}</v-card-text>
                                            <v-card-text><v-icon color="#871B12"> mdi-email </v-icon><strong>อีเมล์ : </strong>{{ formUpdate.empEmail }} </v-card-text>
                                        </v-col>

                                        <v-card-actions>
                                            <v-btn
                                            color="cyan"
                                            text
                                            @click="pushInfo">
                                                แก้ไขข้อมูล
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                    <!-- end -->

                    <!-- ข้อมูลที่อยู่ -->
                    <v-col cols="12">
                        <v-expansion-panels focusable v-model="panel1" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header disable-icon-rotate>
                                <template v-slot:actions>
                                    <v-icon color="#871B12"> mdi-home-circle-outline </v-icon>
                                </template>
                            ข้อมูลที่อยู่
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                            <v-card elevation="2">
                                    <v-card>
                                    <v-card-text>{{ formAddress.empAddressStatus }}</v-card-text>
                                    <v-col>
                                        <v-card-text><v-icon color="#871B12"> mdi-home-edit </v-icon><strong>บ้านเลขที่ : </strong>{{ formAddress.empAddressName }}<v-icon color="#871B12"> mdi-home-map-marker </v-icon><strong>ตำบล/แขวง : </strong>{{ formAddress.empAddressSubDistrict }}</v-card-text>
                                        <v-card-text><v-icon color="#871B12"> mdi-home-map-marker </v-icon><strong>อำเภอ/เขต : </strong>{{ formAddress.empAddressDistrict }} <v-icon color="#871B12"> mdi-home-map-marker </v-icon><strong> จังหวัด : </strong>{{ formAddress.empAddressProvine }}</v-card-text>
                                        <v-card-text><v-icon color="#871B12"> mdi-home-minus </v-icon><strong>รหัสไปรษณีย์ : </strong>{{ formAddress.empAddressZipcode }}</v-card-text>
                                        <v-card-text><v-icon color="#871B12"> mdi-home-variant-outline </v-icon><strong>ประเภทที่พัก : </strong>{{ formAddress.empAddressType }}</v-card-text>
                                    </v-col>

                                    <v-card-actions>
                                        <v-btn
                                        color="cyan"
                                        text
                                        @click="pushAddress">
                                            แก้ไขข้อมูล
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                    <!-- end -->

                    <!-- ข้อมูลครอบครัว -->
                    <v-col cols="12">
                        <v-expansion-panels focusable v-model="panel2" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header disable-icon-rotate>
                                <template v-slot:actions>
                                    <v-icon color="#871B12"> mdi-human-greeting </v-icon>
                                </template>
                            ข้อมูลครอบครัว
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                            <v-card elevation="2">
                                <v-card>
                                <v-alert v-if="dataFamily.length == 0"
                                  border="right"
                                  colored-border
                                  type="error"
                                  elevation="20"
                                >
                                  กรุณาเพิ่มข้อมูลครอบครัว  อย่างน้อย 1 รายการ  Please enter  at least 1 item.
                                </v-alert>
                                    <div v-for="(items, index) in dataFamily" :key="index">
                                            <v-card-text>
                                                    <v-row>
                                                        <v-card-text><v-icon color="#871B12"> mdi-account-circle-outline </v-icon><strong> {{ items.familyStatus }}</strong></v-card-text>
                                                            <v-col>
                                                                <v-card-text><v-icon color="#871B12"> mdi-account </v-icon><strong>ชื่อ-นามสกุล : </strong>{{ items.familyTitleName }}  {{ items.familyFirstName }}  {{ items.familyLastName }}</v-card-text>
                                                                <v-card-text><v-icon color="#871B12"> mdi-layers </v-icon><strong>อาชีพ : </strong>{{ items.familyCareer }}  <v-icon color="#871B12"> mdi-map-marker-radius </v-icon><strong>  ที่อยู่ / ที่ทำงาน : </strong>{{ items.familyAddress }}</v-card-text>
                                                                <v-card-text><v-icon color="#871B12"> mdi-cellphone-basic </v-icon><strong>เบอร์โทรศัพท์ : </strong>{{ items.familyTel }}</v-card-text>
                                                            </v-col>
                                                    </v-row>
                                            </v-card-text>
                                        <br>
                                    </div>

                                    <v-card-actions>
                                        <v-btn
                                        color="cyan"
                                        text
                                        @click="pushFamily">
                                            แก้ไขข้อมูล
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                    <!-- end -->

                    <!-- ข้อมูลการศึกษา -->
                    <v-col cols="12">
                        <v-expansion-panels focusable v-model="panel3" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header disable-icon-rotate>
                                <template v-slot:actions>
                                    <v-icon color="#871B12"> mdi-school </v-icon>
                                </template>
                            ข้อมูลการศึกษา
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                            <v-card elevation="2">
                                    <v-card>
                                        <v-card-text><v-icon color="#871B12"> mdi-school </v-icon><strong>   การศึกษา</strong></v-card-text>
                                        <v-col>
                                            <v-card-text><strong>ระดับการศึกษา : </strong>{{ formEducation.educationLevel }}  <strong>ชื่อสถานศึกษา : </strong>{{ formEducation.educationAddress }}</v-card-text>
                                            <v-card-text><strong>คณะ / หลักสูตร : </strong>{{ formEducation.educationFaculty }}   <strong>สาขาวิชา : </strong>{{ formEducation.educationDepartment }}</v-card-text>
                                            <v-card-text><strong>เกรดเฉลี่ย : </strong>{{ formEducation.educationGrade }}  <strong>สถานะการศึกษา : </strong>{{ formEducation.educationStatus }}  <strong>ปีที่จบ : </strong>{{ formEducation.educationYear }}</v-card-text>
                                            <v-card-text><strong>กลุ่มสถาบันการศึกษา : </strong>{{ formEducation.educationAcademyGroup }}</v-card-text>
                                        </v-col>

                                        <v-card-actions>
                                            <v-btn
                                            color="cyan"
                                            text
                                            @click="pushEducation">
                                                แก้ไขข้อมูล
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                    <!-- end -->

                     <!-- ข้อมูลประสบการทำงาน -->
                    <v-col cols="12">
                        <v-expansion-panels focusable v-model="panel4" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header disable-icon-rotate>
                                <template v-slot:actions>
                                    <v-icon color="#871B12">mdi-briefcase-account</v-icon>
                                </template>
                            ข้อมูลประสบการทำงาน
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                            <v-card elevation="2">
                                   <v-card>
                                        <v-card-text><v-icon color="#871B12"> mdi-briefcase-account </v-icon><strong>   ประสบการทำงาน</strong></v-card-text>
                                        <v-col>
                                            <v-card-text :value="computedDateSD" :return-value.sync="date"><v-icon color="#871B12"> mdi-calendar </v-icon><strong>ตั้งแต่วันที่ : </strong>{{ showSDDate }}</v-card-text>
                                            <v-card-text :value="computedDateED" :return-value.sync="date"><v-icon color="#871B12"> mdi-calendar </v-icon><strong>สิ้นสุดวันที่ : </strong>{{ showEDDate }} <v-icon color="#871B12"> mdi-account-tie </v-icon><strong>ตำแหน่งงาน : </strong>  {{ formExperience.lastPosition }}</v-card-text>
                                            <v-card-text><strong>ชื่อบริษัท : </strong>{{ formExperience.lastWorkExpName }} <v-icon color="#871B12"> mdi-map-marker-radius </v-icon><strong>  ที่อยู่ที่ทำงาน :  </strong>  {{ formExperience.workExpAddress }}</v-card-text>
                                            <v-card-text><strong>ลักษณะงาน : </strong>{{ formExperience.jobDescription }}</v-card-text>
                                            <v-card-text><strong>เหตุผลที่ลาออก : </strong>{{ formExperience.reasonResignation }}</v-card-text>
                                        </v-col>

                                        <v-card-actions>
                                            <v-btn
                                            color="cyan"
                                            text
                                            @click="pushExperience">
                                                แก้ไขข้อมูล
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                    <!-- end -->

                    <!-- ข้อมูลประกัน -->
                    <v-col cols="12">
                        <v-expansion-panels focusable v-model="panel5" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header disable-icon-rotate>
                                <template v-slot:actions>
                                    <v-icon color="#871B12"> mdi-shield-cross </v-icon>
                                </template>
                            ข้อมูลประกัน
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                            <v-card elevation="2">
                                    <v-card>
                        <v-card-text><v-icon color="#871B12"> mdi-clipboard-plus </v-icon>ประกันสุขภาพ</v-card-text>
                        <v-col>
                            <v-card-text><strong>สถานพยาบาล : </strong>{{ formHealth.healthAddress }}</v-card-text>
                            <v-card-text><strong>เบอร์โทรศัพท์ : </strong>{{ formHealth.healthTel }}</v-card-text>
                            <v-card-text><strong>เลขที่รับแจ้ง : </strong>{{ formHealth.healthNumber }}</v-card-text>
                            <v-card-text :value="computedDate1" :return-value.sync="date"><v-icon color="#871B12"> mdi-calendar </v-icon><strong>วันที่เริ่มใช้สิทธิ์ : </strong>{{ showDate1 }}</v-card-text>
                            <v-card-text :value="computedDate2" :return-value.sync="date"><v-icon color="#871B12"> mdi-calendar </v-icon><strong>วันที่หมดอายุ : </strong>{{ showDate2 }}</v-card-text>
                            <v-card-text><strong>กรมธรรม์เลขที่ : </strong>{{ formHealth.healthGroupNumber }}</v-card-text>
                            <v-card-text><strong>บริษัท ประกัน : </strong>{{ formHealth.empHealthName }}</v-card-text>
                            <v-card-text :value="computedDate3" :return-value.sync="date"><v-icon color="#871B12"> mdi-calendar </v-icon><strong>วันที่เริ่มคุ้มครอง : </strong>{{ showDate3 }}</v-card-text>
                            <v-card-text :value="computedDate4" :return-value.sync="date"><v-icon color="#871B12"> mdi-calendar </v-icon><strong>เข้าระบบ / ต่ออายุ : </strong>{{ showDate4 }}</v-card-text>
                            <v-card-text :value="computedDate5" :return-value.sync="date"><v-icon color="#871B12"> mdi-calendar </v-icon><strong>วันที่ เริ่มคุ้มครอง : </strong>{{ showDate5 }}</v-card-text>
                            <v-card-text :value="computedDate6" :return-value.sync="date"><v-icon color="#871B12"> mdi-calendar </v-icon><strong>วันที่ สิ้นสุดคุ้มครอง : </strong>{{ showDate6 }}</v-card-text>
                        </v-col>

                        <v-card-actions>
                            <v-btn
                            color="cyan"
                            text
                            @click="pushHealth">
                                แก้ไขข้อมูล
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                    <!-- end -->

                    <!-- ความสามารถ && งานอดิเรก -->
                    <v-col cols="12">
                        <v-expansion-panels focusable v-model="panel6" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header disable-icon-rotate>
                                <template v-slot:actions>
                                    <v-icon color="#871B12"> mdi-bullseye-arrow </v-icon>
                                </template>
                            ความสามารถพิเศษ & งานอดิเรก
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                            <v-card elevation="2">
                                    <v-card>
                                    <v-card-text>งานอดิเรก</v-card-text>
                                    <v-col>
                                        <v-card-text><v-icon color="#871B12">  mdi-crown-outline  </v-icon><strong>งานอดิเรก : </strong><v-card-text>
                                            <v-chip v-for="i in formUpdate.hobby"
                                            :key="i">{{ i }}</v-chip>
                                        </v-card-text></v-card-text>
                                        <v-card-text><v-icon color="#871B12"> mdi-crystal-ball </v-icon><strong>ความสามารถทางอาชีพ : </strong>{{ formUpdate.empGenius }}</v-card-text>
                                    </v-col>
                                    <v-card-actions>
                                        <v-btn
                                        color="cyan"
                                        text
                                        @click="pushInfo">
                                            แก้ไขข้อมูล
                                        </v-btn>
                                    </v-card-actions>
                                    <v-divider></v-divider>
                                    <v-card-text>ความสามารถด้านภาษา</v-card-text>
                                    <v-alert v-if="dataLanguageSkill.length == 0"
                                      text
                                      dense
                                      color="red"
                                      icon="mdi-clock-fast"
                                      border="left"
                                    >
                                      กรุณาเพิ่มทักษะทางภาษา อย่างน้อย 1 รายการ ( ถ้ามี * ) Please enter at least 1 item.
                                    </v-alert>
                                    <div v-for="(items, index) in dataLanguageSkill" :key="index">
                                    <v-col>
                                        <v-card-text>
                                            <v-icon color="#871B12">  mdi-google-translate  </v-icon><strong>ภาษา : </strong>{{ items.languageCode }}
                                        </v-card-text>
                                        <v-card-text>
                                          <v-row>
                                            <v-col cols="12" sm="4">
                                               <v-icon color="#871B12"> mdi-web </v-icon><strong>การอ่าน : </strong>{{ items.empLanguageRead }}
                                            </v-col>
                                            <v-col  cols="12" sm="4">
                                               <v-icon color="#871B12">  mdi-web  </v-icon><strong>การพูด : </strong>{{ items.empLanguageSpeak }}
                                            </v-col>
                                            <v-col  cols="12" sm="4">
                                               <v-icon color="#871B12"> mdi-web </v-icon><strong>การเขียน : </strong>{{ items.empLanguageWrite }}
                                            </v-col>
                                          </v-row>
                                        </v-card-text>
                                    </v-col>
                                    </div>
                                    <v-card-actions>
                                        <v-btn
                                        color="cyan"
                                        text
                                        @click="pushLanguage">
                                            แก้ไขข้อมูล
                                        </v-btn>
                                    </v-card-actions>
                                    <v-divider></v-divider>
                                    <v-card-text>ความสามารถด้านคอมพิวเตอร์</v-card-text>
                                    <v-alert v-if="dataComSkill.length == 0"
                                      border="right"
                                      colored-border
                                      type="error"
                                      elevation="20"
                                    >
                                      กรุณาเพิ่มทักษะทางคอมพิวเตอร์  อย่างน้อย 1 รายการ  ( ถ้ามี * )  Please enter at least 1 item.
                                    </v-alert>
                                    <div v-for="(item, index) in dataComSkill" :key="index">
                                    <v-col>
                                        <v-card-text><v-icon color="#871B12">  mdi-microsoft-windows  </v-icon><strong>ความสามารถทางคอมพิวเตอร์ : </strong>{{ item.masComputerSkillCode }}</v-card-text>
                                        <v-card-text><v-icon color="#871B12"> mdi-monitor-multiple </v-icon><strong>ระดับ ความสามารถ : </strong>{{ item.empComputerSkillScore }}</v-card-text>
                                    </v-col>
                                    </div>
                                    <v-card-actions>
                                        <v-btn
                                        color="cyan"
                                        text
                                        @click="pushCom">
                                            แก้ไขข้อมูล
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                    <!-- end -->

                </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
</div>
</template>
<script>
import axios from 'axios' // api
import EmpMenu from './EmployeeMenu.vue'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-emp-menu': EmpMenu,
    moment
  },
  computed: {
    computedDateBB () {
      if (this.formUpdate.empBirthday) {
        let dateTh = moment(this.formUpdate.empBirthday)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTH = dateTh
        return this.showDateTH
      }
    },
    computedDateDD () {
      if (this.formUpdate.issuedDate) {
        let dateTh1 = moment(this.formUpdate.issuedDate)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showIssuedDate = dateTh1
        return this.showIssuedDate
      }
    },
    computedDateEE () {
      if (this.formUpdate.expireDate) {
        let dateTh2 = moment(this.formUpdate.expireDate)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showExpireDate = dateTh2
        return this.showExpireDate
      }
    },
    computedDateSD () {
      if (this.formExperience.startDate) {
        let dateTh3 = moment(this.formExperience.startDate)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showSDDate = dateTh3
        return this.showSDDate
      }
    },
    computedDateED () {
      if (this.formExperience.endDate) {
        let dateTh4 = moment(this.formExperience.endDate)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showEDDate = dateTh4
        return this.showEDDate
      }
    },
    computedDate1 () {
      if (this.formHealth.healthStartDate) {
        let dateTh4 = moment(this.formHealth.healthStartDate)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDate1 = dateTh4
        return this.showDate1
      }
    },
    computedDate2 () {
      if (this.formHealth.healthExpireDate) {
        let dateTh4 = moment(this.formHealth.healthExpireDate)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDate2 = dateTh4
        return this.showDate2
      }
    },
    computedDate3 () {
      if (this.formHealth.healthGroupStartDate) {
        let dateTh4 = moment(this.formHealth.healthGroupStartDate)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDate3 = dateTh4
        return this.showDate3
      }
    },
    computedDate4 () {
      if (this.formHealth.healthGroupRenew) {
        let dateTh4 = moment(this.formHealth.healthGroupRenew)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDate4 = dateTh4
        return this.showDate4
      }
    },
    computedDate5 () {
      if (this.formHealth.healthGroupStart) {
        let dateTh4 = moment(this.formHealth.healthGroupStart)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDate5 = dateTh4
        return this.showDate5
      }
    },
    computedDate6 () {
      if (this.formHealth.healthGroupEnd) {
        let dateTh4 = moment(this.formHealth.healthGroupEnd)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDate6 = dateTh4
        return this.showDate6
      }
    }
  },
  data () {
    return {
      rollHR: false,
      showDateTH: '',
      showIssuedDate: '',
      showExpireDate: '',
      showSDDate: '',
      showEDDate: '',
      showDate1: '',
      showDate2: '',
      showDate3: '',
      showDate4: '',
      showDate5: '',
      showDate6: '',
      panel: [0],
      panel1: [1],
      panel2: [1],
      panel3: [1],
      panel4: [1],
      panel5: [1],
      panel6: [1],
      value: 1,
      PK: '',
      path: '/employee/', // Path Model
      // Menu Config
      session: this.$session.getAll(),
      // End Menu Config
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      dataImg: '',
      formUpdate: {
        empCode: '',
        empFull_NameTH: '',
        empTitle_NameTH: '',
        empFirst_NameTH: '',
        empLast_NameTH: '',
        empFull_NameEN: '',
        empTitle_NameEN: '',
        empFirst_NameEN: '',
        empLast_NameEN: '',
        empNickname: '',
        empBirthday: '',
        empGender: '',
        empIDCard: '',
        empEmail: '',
        empTel: '',
        issuedDate: '',
        expireDate: '',
        issuedAt: '',
        issuedProvince: '',
        empImageUrl: '',
        showDateTH: ''
      },
      dataAddress: [],
      formAddress: {
        empCode: '',
        empAddressName: '',
        empAddessStatusMessenger: '',
        empAddressSubDistrict: '',
        empAddressDistrict: '',
        empAddressProvine: '',
        empAddressZipcode: '',
        empAddressType: '',
        empAddressStatus: ''
      },
      dataExperince: [],
      formExperience: {
        empCode: '',
        workId: '',
        lastWorkExpName: '',
        startDate: '',
        endDate: '',
        workExpAddress: '',
        lastPosition: '',
        lastSalary: '',
        expSupervisor: '',
        expSupervisorEmail: '',
        expSupervisorTel: '',
        jobDescription: '',
        reasonResignation: ''
      },
      dataFamily: [],
      dataEducation: [],
      formEducation: {
        empCode: '',
        educationLevel: '',
        educationAddress: '',
        educationFaculty: '',
        educationDepartment: '',
        educationYear: '',
        educationGrade: '',
        educationStatus: '',
        educationAcademyGroup: ''
      },
      dataHealth: [],
      formHealth: {
        empCode: '',
        healthGroupNumber: '',
        healthGroupStartDate: '',
        healthGroupRenew: '',
        healthGroupStart: '',
        healthGroupEnd: '',
        healthAddress: '',
        healthTel: '',
        healthNumber: '',
        healthStartDate: '',
        healthExpireDate: '',
        empHealthName: ''
      },
      dataLanguageSkill: [],
      dataComSkill: [],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      titleNameTH: [],
      titleNameEN: [],
      get_gender: [],
      empId: '',
      empCode: '',
      dataEmp: '',
      empAddressID: '',
      workId: '',
      familyID: ''
    }
  },
  async mounted () {
    this.dataReady = false
    await this.getGetTokenForEmployee()
    await this.checkEmpData()
  },
  methods: {
    // async getDataInfo () {},
    async checkEmpData () {
      this.can = localStorage.getItem('CanEdit')
      this.can = (this.can === 'true')
      if (localStorage.getItem('roll') === 'Employee') {
        this.dataEmp = JSON.parse(localStorage.getItem('data'))
      } else if (localStorage.getItem('roll') === 'HR') {
        this.rollHR = true
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      } else {
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      }
      if (localStorage.getItem('roll')) {
        await this.reloadDataById()
      }
    },
    async reloadDataById () {
      await this.getDataById()
      await this.getDataByAddress()
      await this.getDataByExperience()
      await this.getDataByFamily()
      await this.getDataByEducation()
      await this.getDataByHealth()
      await this.getDataByLanguage()
      await this.getDataByComSkill()
    },
    async getDataById () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "getEmpCode?empCode=" + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            Object.assign(this.formUpdate, response.data[0])
            this.formUpdate.hobby = JSON.parse(this.formUpdate.hobby)
            this.dataImg = this.DNS_IP + '/' + this.formUpdate.empImageUrl
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    },
    async getDataByAddress () {
      this.dataAddress = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_address/" + "getEmpCode?empCode=" + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            //   Object.assign(this.formAddress, response.data[0])
            this.dataAddress = response.data
            var dtAddress = this.dataAddress.filter(function (el) {
              return el.empAddressStatus === 'ที่อยู่ปัจจุบัน'
            })
            this.formAddress.empAddressName = dtAddress[0].empAddressName
            this.formAddress.empAddessStatusMessenger = dtAddress[0].empAddessStatusMessenger
            this.formAddress.empAddressSubDistrict = dtAddress[0].empAddressSubDistrict
            this.formAddress.empAddressDistrict = dtAddress[0].empAddressDistrict
            this.formAddress.empAddressProvine = dtAddress[0].empAddressProvine
            this.formAddress.empAddressZipcode = dtAddress[0].empAddressZipcode
            this.formAddress.empAddressType = dtAddress[0].empAddressType
            this.formAddress.empAddressStatus = dtAddress[0].empAddressStatus
          }
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async getDataByExperience () {
      this.dataExperince = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/emp_experience/" + "getEmpCode?empCode=" + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            Object.assign(this.formExperience, response.data[0])
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async getDataByFamily () {
      this.dataFamily = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_family/" + "getEmpCode?empCode=" + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            Object.assign(this.dataFamily, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async getDataByEducation () {
      this.dataEducation = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_education/" + "getEmpCode?empCode=" + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            Object.assign(this.formEducation, response.data[0])
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataByEducation : ', error)
        })
    },
    async getDataByHealth () {
      this.dataHealth = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_health/" + "getEmpCode?empCode=" + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            Object.assign(this.formHealth, response.data[0])
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async getDataByLanguage () {
      this.dataLanguageSkill = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_language_skill/" + 'getEmpCode?empCode=' + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            Object.assign(this.dataLanguageSkill, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async getDataByComSkill () {
      this.dataComSkill = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_computer_skill/" + "getEmpCode?empCode=" + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            Object.assign(this.dataComSkill, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    pushInfo () {
      this.$router.push(
        '/HRM/Employee/EmployeeInfo'
      )
    },
    pushAddress () {
      this.$router.push(
        '/HRM/Employee/EmployeeAddress'
      )
    },
    pushEducation () {
      this.$router.push(
        '/HRM/Employee/EmployeeEducation'
      )
    },
    pushFamily () {
      this.$router.push(
        '/HRM/Employee/EmployeeFamily'
      )
    },
    pushExperience () {
      this.$router.push(
        '/HRM/Employee/EmployeeExperience'
      )
    },
    pushHealth () {
      this.$router.push(
        '/HRM/Employee/EmployeeSso'
      )
    },
    pushLanguage () {
      this.$router.push(
        '/HRM/Employee/EmployeeLanguageSkill'
      )
    },
    pushCom () {
      this.$router.push(
        '/HRM/Employee/EmployeeComputerSkill')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeInfoMerge.vue